import { useState } from 'react';

import { getCookie } from '@api/HelperAPI';
import { tracking } from '@iwoca/frontend-tracking-library';

import { getCountry } from '../../iwIntlProvider/CountryProvider';

const HIDE_SPILL_BANNER_COOKIE_NAME = 'hideSpillBanner';
const FOUR_WEEKS_IN_SECONDS = 60 * 60 * 24 * 28;

export const useShowSpillBanner = () => {
    const [hideBanner, setHideBanner] = useState(
        () => getCookie(HIDE_SPILL_BANNER_COOKIE_NAME) === 'true'
    );

    const country = getCountry();
    const showSpillBanner = !hideBanner && country !== 'DE';

    const closeSpillBanner = () => {
        setHideBanner(true);
        tracking.ampli.spillBannerClosed();
        document.cookie = `${HIDE_SPILL_BANNER_COOKIE_NAME}=true;max-age=${FOUR_WEEKS_IN_SECONDS}`;
    };

    return { showSpillBanner, closeSpillBanner };
};
